import React from 'react';
import { HeroSection } from './components/HeroSection';
import { TestimonialsInitial } from './components/TestimonialsInitial';
import { StorySection } from './components/StorySection';
import { PainPoints } from './components/PainPoints';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingSection } from './components/PricingSection';
import { ComparisonTable } from './components/ComparisonTable';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostTable } from './components/CostTable';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-navy-900 text-white font-sans selection:bg-gold-500/30" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <TestimonialsInitial data-id="element-3" />
        <StorySection data-id="element-4" />
        <PainPoints data-id="element-5" />
        <TomosSection data-id="element-6" />
        <BonusSection data-id="element-7" />

        {/* First Countdown & Pricing Block */}
        <div id="pricing" className="bg-navy-900/50 py-12 border-y border-navy-800" data-id="element-8">
          <CountdownTimer data-id="element-9" />
          <PricingSection data-id="element-10" />
        </div>

        <ComparisonTable data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FAQSection data-id="element-14" />
        <CostTable data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>

      <Footer data-id="element-17" />
      <SocialProofPopup data-id="element-18" />
    </div>;
}